<template>
  <div class="background">
    <div v-if="showSpinner" class="spinner-container">
      <spinner-el />
    </div>
    <div
      v-else
      class="recent-login__container"
      :class="{'recent-login__container_full-version': !smallVersion}"
    >
      <head-title class="head-title">
        Notifications History
      </head-title>
      <table-el v-if="notificationsHistoryTotalCount" gray class="table">
        <tr slot="thead">
          <th class="table__th table__th_text">TEXT</th>
          <th class="table__th table__th_time">TIME</th>
          <th class="table__th table__th_channels">CHANNELS</th>
        </tr>
        <tr slot="tbody" v-for="notification in notificationsHistoryList" :key="notification.id" class="table__tr">
          <td class="table__td table__td_text">{{notification.text}}</td>
          <td class="table__td table__td_time">{{notification.createdAt | formatDate}}</td>
          <td class="table__td table__td_channels">{{notification.channels | generateChannelsList}}</td>
        </tr>
      </table-el>
      <span v-if="!notificationsHistoryTotalCount" class="notifications-empty__text">There are no entries yet...</span>
      <load-more-btn v-else-if="showLoadMore" :disabled="loadingMore" class="load-more" @click="loadMore" :count="loadMoreCount"></load-more-btn> <!-- TODO add logic for show load more btn -->
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import { formatDate, getAvailableCountForLoadingMore, generateChannelsList } from 'src/utils/helpers';

  export default {
    props: {
      title: String,
      smallVersion: Boolean,
    },
    data: () => ({
      showSpinner: true,
      loadingMore: false,
    }),
    computed: {
      ...mapState('userData', [
        'notificationsHistoryList',
        'notificationsHistoryTotalCount',
      ]),
      showLoadMore() {
        return this.notificationsHistoryList.length < this.notificationsHistoryTotalCount;
      },
      loadMoreCount() {
        return getAvailableCountForLoadingMore(this.notificationsHistoryTotalCount, this.notificationsHistoryList.length); // eslint-disable-line
      },
    },
    methods: {
      ...mapActions('userData', [
        'updateNotificationsHistory',
        'loadMoreNotificationsHistory',
      ]),
      loadMore() {
        this.loadingMore = true;
        this.loadMoreNotificationsHistory().then(() => {
          this.loadingMore = false;
        });
      },
    },
    filters: {
      formatDate,
      generateChannelsList,
    },
    mounted() {
      this.updateNotificationsHistory().then(() => {
        this.showSpinner = false;
      });
    },
  };
</script>

<style scoped lang="scss">
  .spinner {
    margin: auto;
  }
  .spinner-container {
    position: absolute;
    top: 0;
  }
  .background {
    @include background;
  }
  .table {
    text-align: left;
    width: 100%;
  }
  .table__th {
    padding: 12px 0 12px 30px !important;
  }
  .table__td {
    padding: 17px 0 14px 30px;
  }

  .table__th_text,
  .table__td_text {
    width: 61%;
  }

  .table__th_time,
  .table__td_time {
    width: 16%;
  }
  .table__td_channels {
    line-height: 21px;
  }
  .table__tr {
    border-bottom: 1px solid $grey-color3;
  }
  .head-title {
    margin-bottom: 32px;
    margin-left: 30px;
  }
  .recent-login__container {
    margin: 0 90px;
    max-width: 1200px;
    border-radius: 5px;
    background: $white-color2;
    padding: 31px 0 0;
    &_full-version {
      @media only screen and (max-width : 900px) {
        margin: 0 10px;
        .table__td {
          padding: 12px 6px;
          line-height: 16px;
        }
        .table__th {
          padding: 12px !important;
        }
      }
      @media only screen and (max-width : 450px) {
        .head-title {
          margin-left: 12px;
        }
      }
    }
  }
  .load-more {
    padding: 30px !important;
    display: block;
  }
  .top-title {
    display: inline-block;
  }
  .all-entries {
    padding: 19px 31px 22px;
    @include font(13px, $grey-color9, 500);
    &__link {
      text-decoration: none;
      color: $red-color3 !important;
    }
  }
  .notifications-empty__text {
    @include font(13px, $grey-color9, 500);
    padding: 19px 31px 20px;
    display: block;
    border-top: 1px solid #E5E5E5;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Notifications.vue